import { createContext } from 'react';

export interface MainCouranteMessage {
  id: string;
  author_id: string;
  author_name: string;
  title: string;
  description: string;
  created_at: string;
  updated_at: string;
}

export interface MainCouranteContextType {
  messages: MainCouranteMessage[];
  loading: boolean;
  error: string;
  unreadCount: number;
  latestUnreadMessage: MainCouranteMessage | null;
  unreadMessages: MainCouranteMessage[];
  createMessage: (title: string, description: string) => Promise<boolean>;
  updateMessage: (id: string, title: string, description: string) => Promise<boolean>;
  deleteMessage: (id: string) => Promise<boolean>;
  markAsRead: () => void;
  refresh: () => Promise<void>;
}

export const MainCouranteContext = createContext<MainCouranteContextType | undefined>(undefined);
